import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useResidentialZoneCreateMutation } from "src/hooks/residential-zones";
import { ResidentialZoneForm, ResidentialZoneFormData } from "src/forms/ResidentialZoneForm";

interface Props {
  map: L.Map;
  onClose: () => void;
}

export function ResidentialZoneCreatePage(props: Props) {
  const { t } = useTranslation();
  const { caseId = "", scenarioId = ""} = useParams<{
    caseId: string;
    scenarioId: string;
    // residentialZoneId: string;
  }>();
  const navigate = useNavigate();
  const createMutation = useResidentialZoneCreateMutation(scenarioId);

  async function handleSave(values: ResidentialZoneFormData) {
    const result = await createMutation.mutateAsync({
      ...values,
    });
    navigate(`/cases/${caseId}/scenarios/${scenarioId}/residential-zones/${result.id}`);
  }

  return render();

  function render() {
    return (
      <ResidentialZoneForm
        map={props.map}
        title={t("label.addResidentialZone")}
        data={{
          name: "",
          polygon_frontendSrid: "",
        }}
        onClose={() => props.onClose()}
        onSubmit={handleSave}
        isLoading={createMutation.isLoading}
        errors={createMutation.error?.response?.data}
      />
    );
  }
}
